module.exports = __webpack_public_path__ + "static/avianca-756c5703fe6c483413826d56739af00f.png";